import React, { useEffect, useState } from "react";
import Modal from "react-bootstrap/Modal";
import { BaseUrl } from "../../../../Container/BaseUrl/BaseUrl";
import axios from "axios";
import { toast } from "react-toastify";
import { connect } from "react-redux";
import {
  setExternalChatData,
  setcontactlist,
  UpdateExternalContactList,
} from "../../../../Redux/Actions/actions";
import { toaststyle } from "../../../../Utils/toaststyle";
import { Box, Button } from "@mui/material";

const mapStateToProps = (state) => {
  return {
    chat: state.data.chat,
    chatid: state.data.chatid,
    selectedchanneldata: state.data.selectedchanneldata,
  };
};

const Transfersupervisormodel = (props) => {
  const { show, close } = props;
  const [availableAgent, setAvailableAgent] = useState([]);
  const [value, setSelectedValue] = useState("");

  const getAvailableAgents = async () => {
    const access_token = localStorage.getItem("access_token");

    try {
      let userId = JSON.parse(localStorage.getItem("tokenAgent"));
      let passUserId = userId.user_id;
      const data = await axios.post(
        BaseUrl + "/users/listSupervisor",
        {},
        {
          headers: {
            Authorization: "Bearer " + access_token,
            "Content-Type": "application/json",
            tenantId: localStorage.getItem("TenantId"),
          },
        }
      );
      if (data.data.status) {
        setAvailableAgent(data.data.data);
      }
    } catch (error) {
      // errorHandel(error, "/users/listSupervisor")
    }
  };

  const escalationSubmitButton = async (value) => {
    let old_agent_id = JSON.parse(localStorage.getItem("tokenAgent"));
    let sessionId = JSON.parse(localStorage.getItem("client"));
    let dataToPass = {
      sessionId: sessionId.chat_session_id,
      agentId: value,
      oldAgentId: old_agent_id.id,
    };
    axios
      .post(BaseUrl + "/users/transferAgent", dataToPass, {
        headers: {
          Authorization: "Bearer " + localStorage.getItem("access_token"),
          "Content-Type": "application/json",
          tenantId: localStorage.getItem("TenantId"),
        },
      })
      .then((response) => {
        if (response.data.status) {
          props.setExternalChatData('')
          props.UpdateExternalContactList(
            JSON.parse(localStorage.getItem("client")).chat_session_id
          );
          close();
        } else {
          props.setExternalChatData('')
          close();
        }
      });
  };

  useEffect(() => {
    getAvailableAgents();
  }, []);

  return (
    <>
      <Modal show={show} onHide={close} maxWidth="sm" fullWidth>
        <Modal.Header
          style={{
            fontSize: "16px",
            fontWeight: 600,
            boxShadow:
              "rgba(50, 50, 93, 0.25) 0px 2px 5px -1px, rgba(0, 0, 0, 0.3) 0px 1px 3px -1px",
          }}
        >
          <Modal.Title style={{ fontSize: "16px", fontWeight: 600 }}>
            Reassign to supervisor
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <label for="exampleFormControlTextarea1" className="form-label fs-13">
            Available Supervisor
          </label>
          <select
            className="form-select fs-13"
            name="availableAgent"
            value={value}
            onChange={(e) => setSelectedValue(e.target.value)}
          >
            <option value="agent" selected>
              Select supervisor
            </option>
            {availableAgent.map((agents) => {
              return (
                <option value={agents.agent_id}>
                  {agents.username ? agents.username : agents.firstName}
                </option>
              );
            })}
          </select>
        </Modal.Body>
        <Modal.Footer style={{ borderTop: "0px" }}>
          <Button
            sx={{ textTransform: "capitalize !important" }}
            variant="outlined"
            onClick={() => {
              close();
            }}
            size="small"
            disableElevation
            color="error"
            autoFocus
            className="me-2"
          >
            Close
          </Button>
          <Button
            onClick={() => escalationSubmitButton(value)}
            vautoFocus
            sx={{ textTransform: "capitalize !important" }}
            variant="contained"
            size="small"
            disableElevation
          >
            Transfer
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default connect(mapStateToProps, {
  setExternalChatData,
  setcontactlist,
  UpdateExternalContactList,
})(Transfersupervisormodel);
